import { render } from "./NewIssue.vue?vue&type=template&id=141e549e"
import script from "./NewIssue.vue?vue&type=script&lang=js"
export * from "./NewIssue.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__